import React from 'react';
import { Select } from 'antd';
import useTranslation from '@src/hooks/useTranslation';
import styled from 'styled-components';

import { CloseIcon, ArrowDownIcon } from '@src/components/common/icon';

const { Option, OptGroup } = Select;

export const StyledGroupSelect = styled(Select)`
	width: 100% !important;
	:hover {
		border: unset;
	}

	& .ant-select-selector {
		height: 37px !important;
		padding: 0 12px !important;
		border-radius: 4px !important;
		box-shadow: unset !important;
		padding: 4px 8px;
		border: 1px solid #DDDDDD !important;
		&:active {
			border: 1px solid #101010 !important;
		}
		&:focus {
			border: 1px solid #101010 !important;
		}
		&:hover {
			border: 1px solid #101010 !important;
		}
	}

	& .ant-select-selector .ant-select-selection-overflow {
		min-height: 38px;
	}

	& .ant-select-selector .ant-select-selection-item-content {
		font-size: 14px !important;
		margin-right: 2px !important;
		font-weight: 400 !important;
	}

	& .ant-select-selector .ant-select-selection-item {
		font-size: 14px !important;;
		line-height: 37px !important;
		color: #333333;
		font-weight: 400;
	}

	& .ant-select-selector .ant-select-selection-search {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
	}

	& .ant-select-selector .ant-select-selection-item-remove > .anticon {
		vertical-align: unset !important;
	}

	& .ant-select-selector .ant-select-multiple > .anticon {
		vertical-align: unset !important;
	}

	& .ant-select-selector .ant-select-selection-placeholder {
		font-size: 14px;
		line-height: 37px !important;;
		color: #676767;
		font-weight: 300;
	}

	& .ant-select-selector .ant-select-selection-item-remove svg {
		width: 12px;
		height: 12px;
		fill: #676767;
	}

	& .ant-select-selector .ant-select-selection-item-remove {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	& .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
		color: ${props => props.theme.colors.primary} !important;
	}

	& .ant-select-item-option-selected {
		background-color: unset !important;
		:hover {
			background-color: ${props => props.theme.colors.primary}26 !important;
		}
	}
	& .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
		:hover {
			background-color: ${props => props.theme.colors.primary}26 !important;
		}
	}

	& .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
			background-color: ${props => props.theme.colors.primary}26 !important;
		}
	}

	& .ant-select-item {
		font-size: 14px !important;
		font-weight: 400 !important;
		color: #222222 !important;
	}

	& .ant-select-item-group {
		font-weight: 300 !important;
		color: #676767 !important;
	}

	& .ant-select-arrow svg {
		path {
			fill: #B9B9B9;
		}
	}

	& .ant-select-arrow {
		top: calc(50% - 6px);
		/* right: 21px; */
		width: 24px;
		height: 24px;
		transform: rotate(${(props: { $expand: boolean }) => (props.$expand ? 180 : 0)}deg);
		transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}
`;

interface IProps {
	onChange: ({ type, id }) => void;
	isDisabled?: boolean;
	className?: string;
	defaultPlaceholder?: string;
	// hasNone?: boolean;
	// hasAll?: boolean;
	optionId?: string;
	groupOption: {
		groupTitle: string;
		options: {
			id: string;
			title: string;
		}[]
	}[]
}

const GroupSelect = ({
	onChange,
	isDisabled,
	className,
	defaultPlaceholder = '',
	// hasNone,
	// hasAll = true,
	optionId,
	groupOption,
}: IProps): JSX.Element => {
	const { t } = useTranslation();
	const isSelectorLoading = false;

	const handleOnChange = id => {
		onChange({ type: '', id });
	};

	const options = ({ title, list }) => {
		const optionList = list.map(item => (
			<Option key={item.id} value={item.id}>{item.title || ''}</Option>
		));
		if (!title) return optionList;
		return (
			<OptGroup
				key={title}
				label={title}
			>
				{optionList}
			</OptGroup>
		);
	};

	return (
		<div>
			{
				isSelectorLoading ? (
					<StyledGroupSelect
						disabled
						suffixIcon={<ArrowDownIcon />}
						$expand={false}
						className={className}
						value="資料載入中..."
					>
						loading
					</StyledGroupSelect>
				) : (
					<StyledGroupSelect
						showArrow
						suffixIcon={<ArrowDownIcon />}
						removeIcon={CloseIcon}
						getPopupContainer={trigger => trigger.parentNode}
						onChange={handleOnChange}
						placeholder={t(defaultPlaceholder)}
						className={className}
						disabled={isDisabled}
						value={optionId || null}
					>
						{/* {hasAll && (
							<Option
								key={DEFAULT_FILTER_COURSE_OPTION}
								value={DEFAULT_FILTER_COURSE_OPTION}
							>
								{t('filter:order_all')}
							</Option>
						)}
						{
							hasNone && (
								<Option
									key={DEFAULT_NONE_FILTER_COURSE_OPTION}
									value={DEFAULT_NONE_FILTER_COURSE_OPTION}
								>
									{t('filter:none_order')}
								</Option>
							)
						} */}
						{
							groupOption.map(group => options({ title: group.groupTitle, list: group.options }))
						}
					</StyledGroupSelect>
				)
			}
		</div>
	);
};

export default GroupSelect;
